import { Table, TableBody, TableCell as MuiCell, TableHead, TableRow } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { SIZE_FIELDS } from "../../../../utils/algolia/filters";

const sizeTypes = ["AU", "US", "UK", "Size"];

export const sizeCustomFieldKeys = Object.keys(SIZE_FIELDS);

const pantsSizes = {
  //pants_size
  Size: [
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
  ],
};
const shoesSizes = {
  //shoes_size
  AU: [5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5],
  US: [5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5],
  EU: [35, 35, 36, 36, 37, 38, 38, 39, 39, 40, 41, 41, 42, 42, 43, 43, 44, 44],
};
const sizeGuideSizes = {
  //size_guide
  AU: [4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32],
  Size: ["XXS", "XS", "S", "M", "L", "XL", "XXL", "-", "-", "-", "-", "-", "-", "-"],
  UK: [4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32],
  US: [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28],
};
const accessoriesSizes = {
  //accessories_size
  Size: ["XXS", "XS", "S", "M", "L", "XL"],
};

export default function SizeTable({
  categoryName,
  field,
}: {
  categoryName: string;
  field: string;
}) {
  if (field === "pants_size") {
    return (
      <>
        <TableSection
          sizes={pantsSizes}
          title={`${categoryName} Size Guide`}
          sizeTypes={["Size"]}
        />
      </>
    );
  }

  if (field === "shoe_size") {
    return (
      <>
        <TableSection
          sizes={shoesSizes}
          title={`${categoryName} Size Guide`}
          sizeTypes={["AU", "US", "EU"]}
        />
      </>
    );
  }

  if (field === "accessories_size") {
    return (
      <>
        <TableSection
          sizes={accessoriesSizes}
          title={`${categoryName} Size Guide`}
          sizeTypes={["Size"]}
        />
      </>
    );
  }

  if (field === "size_guide") {
    return (
      <>
        <TableSection
          sizes={sizeGuideSizes}
          title={`${categoryName} Size Guide`}
          sizeTypes={sizeTypes}
        />
      </>
    );
  }

  return null;
}

interface SizesProp {
  AU?: number[];
  US?: number[];
  UK?: number[];
  EU?: number[];
  "AU/US/UK"?: number[];
  Size?: string[] | number[];
}

const TableSection = ({
  title,
  sizeTypes,
  sizes,
}: {
  title: string;
  sizeTypes: string[];
  sizes: SizesProp;
}) => (
  <Container>
    <h3>{title}</h3>
    <Table>
      <TableHead>
        <TableRow>
          {sizeTypes.map((sizeType) => (
            <TableCell component="th" key={sizeType}>
              {sizeType}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {sizes[Object.keys(sizes)[0]].map((size, index) => (
          <TableRow key={index}>
            {sizeTypes.map((sizeType) => (
              <TableCell key={sizeType} size="small">
                {sizes[sizeType][index]}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Container>
);

const TableCell = styled(MuiCell)`
  text-align: center;
`;

const Container = styled.div`
  text-align: center;
  max-height: 70vh;
  overflow-y: auto;
  width: 100%;
  pointer-events: auto;
`;
